import React from "react"
import styled from "styled-components"
import heroImage from "../../../assets/images/book-library/img-1.png"
import imgTwo from "../../../assets/images/book-library/img-2.png"
import { Button } from "../../reusableComponents/Button"

function Hero() {
  return (
    <>
      <MainContainer gap={"3rem"}>
        <Container>
          <ColumnWrapper gap={"2rem"}>
            <ColumnWrapper gap={"2rem"}>
              <Title>
                Discover Authors and Their
                <Br />&nbsp;
                Contributions Effortlessly
              </Title>
              <Description>
                Welcome to Author's Trace, your go-to platform for exploring
                author's contributions to
                <Br /> books. Search for books forewords with ease.
              </Description>
            </ColumnWrapper>
            {/* <RowWrapper>
              <Button round="true" primary>
                Learn more
              </Button>
            </RowWrapper> */}
          </ColumnWrapper>
        </Container>
      </MainContainer>
    </>
  )
}

export default Hero

const MainContainer = styled.main`
  padding: 6rem calc((100vw - 1200px) / 2);
  /* padding-bottom: 0rem; */
  width: 100%;
  height: auto;
  background: #EAF2F8;
  position: relative;
  gap: ${({ gap }) => (gap ? gap : "1rem")};

  @media screen and (max-width: 1249px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    box-sizing: border-box;
  }

  @media screen and (max-width: 767px) {
    height: auto;
    flex-direction: column;
  }

  @media screen and (max-width: 500px) {
    padding-bottom: 3rem;
    padding-top: 3rem;
  }
`

const Container = styled.div`
  /* padding: 4rem calc((100vw - 1200px) / 2);
  background: #5890e1; */
  width: 100%;
`

// const AbsoluteContainer = styled.div`
//  width: 100%;
//  /* background: red; */
//  max-height: 300px;
// `

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ? gap : "1rem")};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
`
const RowWrapper = styled.div`
  display: flex;
  gap: ${({ gap }) => (gap ? gap : "1rem")};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
`

const Br = styled.br`
  display: flex;
  @media screen and (max-width: 968px) {
    display: none;
  }
`

const Title = styled.h1`
  /* color: #fff; */
  color: ${props => props.theme.colors.accent7};
  font-size: 60px;
  text-align: center;

  @media screen and (max-width: 767px) {
    font-size: 3rem;
  }

  @media screen and (max-width: 600px) {
    font-size: 2rem;
  }
`

const Description = styled.p`
  /* color: #fff; */
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  color: ${props => props.theme.colors.dark4};

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`
